export default __webpack_public_path__ + "static/media/angelhackcrownred.b66d5814.jpg";